import { createSlice } from "@reduxjs/toolkit";

interface errorState {
  error: boolean;
  message: string;
  title?: string;
  buttonStyle?: "default" | "red";
}

const initialState: errorState = {
  error: false,
  message: "",
  title: undefined,
  buttonStyle: "default",
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setErrorStatus: (
      state,
      action: {
        type: string;
        payload:
          | string
          | {
              message: string;
              title?: string;
              buttonStyle?: "default" | "red";
            };
      }
    ) => {
      state.error = true;
      if (typeof action.payload === "string") {
        state.message = action.payload;
        state.title = undefined;
        state.buttonStyle = "default";
      } else {
        state.message = action.payload.message;
        state.title = action.payload.title;
        state.buttonStyle = action.payload.buttonStyle || "default";
      }
    },
    resetErrorStatus: (state) => {
      state.error = false;
      state.message = "";
      state.title = undefined;
      state.buttonStyle = "default";
    },
  },
});

export const { setErrorStatus, resetErrorStatus } = errorSlice.actions;
export default errorSlice.reducer;
